module.exports = __webpack_public_path__ + "img/kurumaisu_icon_off.3c27c402.png";